<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
        el-col.pt-5.text-right(:span="15")
          el-button(v-if="user.role == 3 ? true : ops.indexOf('transfer_buyer') > -1" type="primary" size="mini" @click="setSourceBuyPerson" :loading="loading") 转派采购员
          el-button(v-if="user.role == 3 ? true : ops.indexOf('add') > -1" type="primary" size="mini" :loading="loading" @click="goto('/purchase/purchase_contract_detail/1/1')") 新增
      el-tabs.title(v-model="activeName" @tab-click="handleTabClick")
        el-tab-pane(:label="'待发布('+count1+')'" name="first")
        el-tab-pane(:label="'审批中('+count2+')'" name="second")
        el-tab-pane(:label="'审批驳回('+count3+')'" name="three")
        el-tab-pane(:label="'审批通过('+count4+')'" name="four")
        el-tab-pane(:label="'变更中('+count5+')'" name="five")
        el-tab-pane(:label="'变更驳回('+count6+')'" name="six")
        el-tab-pane(:label="'全部合同('+count7+')'" name="seven")
    div(style="height:110px")
    el-main.white.pa-3.ma-4
      el-row.py-3(v-if="!flag" type="flex" justify="center")
        el-col(:span="13")
          el-row(type="flex" justify="center" :gutter="10")
            el-col(:span="13")
              el-input.w-100(v-model="list.key_name" placeholder="请输入供应商/物料名称" clearable)
            el-col(:span="11")
              el-button(type="primary" @click="search(1)" :loading="loading") 查询
              el-button(type="text" @click="flag = true" :loading="loading") 高级搜索
      div(v-else)
        el-row.py-3(type="flex" justify="center")
          el-col(:span="22")
            el-row(type="flex" justify="center" :gutter="10")
              el-col(:span="6")
                el-select.w-100(v-model="list.sys_supplier_code" filterable remote placeholder="请搜索供应商" :remote-method="getSupplyList" :loading="loadingSupply" clearable)
                  el-option(v-for="item in supply" :key="item.code" :label="item.name" :value="item.code")
              el-col(:span="6")
                el-input.w-100(v-model="list.code" placeholder="合同档案编号" clearable)
              el-col(:span="6")
                el-input.w-100(v-model="list.material_info" placeholder="物料名称" clearable)
              el-col(:span="6")
                el-date-picker.w-100(v-model="time" type="daterange" align="right" unlink-panels range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions1")
        el-row.py-3(type="flex" justify="center")
          el-col(:span="22")
            el-row(type="flex" justify="start" :gutter="10")
              el-col(:span="6")
                el-select.w-100(v-model="list.buy_org" :filter-method="sourcebuyorg" clearable filterable placeholder="采购组织")
                  el-option(v-for="item in buyorg" :key="item.pk_org" :label="item.name" :value="item.pk_org")
              el-col(:span="6")
                el-select.w-100(v-model="list.buy_person" :loading="loadingPerson" clearable filterable remote placeholder="请选择人员" :remote-method="getPersonList" )
                  el-option(v-for="(item,i) in person" :key="i"  :label="item.name+'-'+item.name_org" :value="item.pk_psndoc")
        //- el-row.py-2(type="flex" justify="center")
        //-   el-col(:span="22")
        //-     el-row(type="flex" justify="center" :gutter="10")
        //-       el-col(:span="6")
        //-         el-select.w-100(v-model="list.status" filterable placeholder="合同状态" clearable)
        //-           el-option(label="审批驳回" :value="-1")
        //-           el-option(label="审批中" :value="0")
        //-           el-option(label="待发布" :value="1")
        //-           el-option(label="审批通过" :value="2")
        //-           el-option(label="审批终止" :value="3")
        //-           el-option(label="变更中" :value="4")
        //-           el-option(label="变更驳回" :value="5")
        el-row.py-1(type="flex" justify="center")
          el-col(:span="12")
            el-row(type="flex" justify="center")
              el-col(:span="10")
                el-button(type="primary" @click="search(2)" :loading="loading") 查询
                el-button(@click="clear") 清空
                el-button(type="text" @click="flag = false" :loading="loading") 收起
      el-table(:data="data" v-loading="loading" row-key="id" size="mini" @selection-change="handleSelectionChange" tooltip-effect="dark")
        el-table-column(type="selection" fixed="left" width="50" key="selection")
        el-table-column(prop="code" label="合同档案编号" width="100" key="code" show-overflow-tooltip)
        el-table-column(prop="name" label="合同名称" width="120" key="name" show-overflow-tooltip)
        el-table-column(prop="supplier_name" label="供应商" width="140" key="supplier_name" show-overflow-tooltip)
        el-table-column(prop="material_info" label="物料" min-width="150" key="material_info" show-overflow-tooltip)
        el-table-column(prop="org_name" label="采购组织" width="140" key="org_name" show-overflow-tooltip)
        el-table-column(prop="do_info" label="执行情况" width="150" key="do_info" show-overflow-tooltip)
        el-table-column(prop="total_money" label="总金额(元)" width="100" key="total_money" show-overflow-tooltip)
        el-table-column(prop="status_name" label="合同状态" width="80" key="status_name")
        el-table-column(prop="create_date" label="创建时间" width="150" key="create_date")
        el-table-column(prop="buy_person_name" label="采购员" width="80" key="buy_person_name" show-overflow-tooltip)
        el-table-column(label="操作" :width="activeName=='seven' ? 100 : activeName=='four' ?260: activeName=='three' ? 300:activeName=='six'?300:200")
          template(slot-scope="scope")
            el-button(v-if="user.role == 3 ? true : ops.indexOf('del') > -1" v-show="activeName=='three'" size="mini" type="danger" plain @click="rollBackSubmit(scope.row)") 删除
            el-button( v-show="activeName=='six'" size="mini" type="danger" plain @click="rollBackChange(scope.row)") 取消变更
            el-button(v-if="user.role == 3 ? true : ops.indexOf('details') > -1" v-show="activeName!='first'  && activeName!='three' && activeName!='six'" size="mini" type="primary" plain @click="goto('/purchase/purchase_contract_detail/'+scope.row.id+'/3')") 详情
            el-button(v-if="user.role == 3 ? true : ops.indexOf('edit') > -1" v-show="activeName=='first' || activeName=='three'" size="mini" type="primary" plain @click="goto('/purchase/purchase_contract_detail/'+scope.row.id+'/2')") 编辑
            el-button(v-if="user.role == 3 ? true : ops.indexOf('change') > -1" v-show="activeName=='four'|| activeName=='six'" size="mini" type="primary" plain @click="goto('/purchase/purchase_contract_detail/'+scope.row.id+'/4')") 变更
            el-button(v-if="user.role == 3 ? true : ops.indexOf('del') > -1" v-show="activeName=='first'" size="mini" type="danger" plain @click="del(scope.row)") 删除
            el-button(v-if="user.role == 3 ? true : ops.indexOf('approval_information') > -1" v-show="activeName!='first' && activeName!='seven'" size="mini" type="primary" plain @click="getApprove(scope.row)") 审批信息
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total,sizes, prev, pager, next, jumper" :total="count" background)
    el-dialog.dialog(title="转派采购员" :visible.sync="dialogFormBuyPerson" width="380px" :show-close="false" :destroy-on-close="true" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="true")
      el-form(:model="formBuyPerson" ref="formBuyPerson" size="mini" :rules="rules")
        el-form-item(prop="pk_psndoc")
          el-select.w-100(v-model="formBuyPerson.pk_psndoc" :loading="loadingPerson" filterable remote placeholder="请选择人员" :remote-method="getPersonList" )
            el-option(v-for="(item,i) in person" :key="i"  :label="item.name+'-'+item.name_org" :value="item.pk_psndoc")
      div(slot="footer" class="dialog-footer")
        el-button(size="mini" @click="dialogFormBuyPerson = false" :loading="loading") 取 消
        el-button(size="mini" type="primary" @click="submitFormBuyPerson" :loading="loading") 确 定
    el-dialog(title="审批信息" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="true" :close-on-press-escape="false")
      el-timeline(v-if="approve.length>0" :reverse="true")
        el-timeline-item(v-for="(item, index) in approve" :key="index" :timestamp="item.time")
          div {{item.nodename+" : "+item.approver}}
          div(v-if="item.opinion") 审批意见 : {{item.opinion}}
      el-alert(v-else title="暂无数据" type="error" :closable="false")
</template>
<script>
export default {
  data () {
    return {
      flag: false,
      h: "",
      loading: false,
      activeName: "first",
      list: {
        is_so: 2,
        code: null,
        key_name: null,
        material_info: null,
        status: 1,
        sys_supplier_code: null,
        time_begin: null,
        time_end: null,
        buy_org: null,
        buy_person: null,
        page_num: 1,
        page_size: 10,
      },
      rules: {
        pk_psndoc: [
          { required: true, message: "请选择采购员", trigger: "change" },
        ],
      },
      formBuyPerson: {
        pk_psndoc: "",
      },
      person: [],
      loadingPerson: false,
      dialogFormBuyPerson: false,
      count: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      count6: 0,
      count7: 0,
      list1: {
        status: 1,
        page_num: 1,
        page_size: 10,
      },
      list2: {
        status: 0,
        page_num: 1,
        page_size: 10,
      },
      list3: {
        status: -1,
        page_num: 1,
        page_size: 10,
      },
      list4: {
        status: 2,
        page_num: 1,
        page_size: 10,
      },
      list5: {
        status: 4,
        page_num: 1,
        page_size: 10,
      },
      list6: {
        status: 5,
        page_num: 1,
        page_size: 10,
      },
      list7: {
        status: null,
        page_num: 1,
        page_size: 10,
      },
      data: [],
      multipleSelection: [],
      time: "",
      loadingSupply: false,
      supply: [],
      approve: [],
      dialogVisible: false,
    };
  },
  methods: {
    async getApprove (e) {
      this.loading = true;
      let type = "";
      if (this.activeName == "second" || this.activeName == "three") {
        type = "ht";
      }
      if (this.activeName == "five" || this.activeName == "six") {
        type = "htbg";
      }
      if (this.activeName == "four") {
        if (e.version == 1) {
          type = "ht";
        } else {
          type = "htbg";
        }
      }
      let res = await this.$api.global.getApprove(type, e.id);
      this.loading = false;
      this.dialogVisible = true;
      if (res) {
        this.approve = res.data;
      } else {
        this.approve = [];
      }
    },
    submitFormBuyPerson() {
      this.$refs["formBuyPerson"].validate(async (valid) => {
        if (valid) {
          let data = [];
          for (var i in this.multipleSelection) {
            data.push({
              id: this.multipleSelection[i].id,
              buy_person: this.formBuyPerson.pk_psndoc,
            });
          }
          let res = await this.$api.purchase_contract.updateList(data);
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
          this.dialogFormBuyPerson = false;
          this.getList();
        } else {
          return false;
        }
      });
    },
    async getPersonList(query) {
      if (!query) {
        return false;
      }
      this.loadingPerson = true;
      let res = await this.$api.global.personList({
        key_name: query,
        page_num: 1,
        page_size: 100,
      });
      this.loadingPerson = false;
      if (res) {
        this.person = res.data;
      }
    },
    setSourceBuyPerson() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }
      this.dialogFormBuyPerson = true;
    },
    clear () {
      this.list.code = null;
      this.list.material_info = null;
      this.list.status = null;
      this.list.sys_supplier_code = null;
      this.list.time_begin = null;
      this.list.time_end = null;
      this.time = "";
      this.list.buy_org =null;
      this.list.buy_person =null;
    },
    del (e) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.$api.purchase_contract.del(e.id);
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.getList();
          }
        })
        .catch(() => { });
    },
    rollBackSubmit (e) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            let res = await this.$api.purchase_contract.rollBackSubmit(e.id);
            if (res) {
              this.$notify({
                message: "操作成功",
                type: "success",
              });
              this.getList();
            }
          })
          .catch(() => { });
    },
    rollBackChange (e) {
      this.$confirm("确定取消变更?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            let res = await this.$api.purchase_contract.rollBackChange(e.id);
            if (res) {
              this.$notify({
                message: "操作成功",
                type: "success",
              });
              this.getList();
            }
          })
          .catch(() => { });
    },
    async getSupplyList (query) {
      if (!query) {
        return false;
      }
      localStorage.setItem("PurchaseContract_query", query);
      this.loadingSupply = true;
      let res = await this.$api.supplier.getotherList({
        key_name: query,
        page_num: 1,
        page_size: 100,
        no_check: 1,
        checkstatus: 3,
        is_blacklist:1
      });
      this.loadingSupply = false;
      if (res) {
        this.supply = res.data;
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    search (type) {
      if (type == 2) {
        this.list.key_name = null;
        if (this.time) {
          this.list.time_begin = this.time[0];
          this.list.time_end = this.time[1];
        } else {
          this.list.time_begin = null;
          this.list.time_end = null;
        }
      } else {
        this.list.code = null;
        this.list.material_info = null;
        this.list.sys_supplier_code = null;
        this.list.time_begin = null;
        this.list.time_end = null;
      }
      /*let status = this.list.status;
      if (status == 1) {
        this.activeName="first";
      } else if(status == 0) {
        this.activeName="second";
      } else if(status == -1) {
        this.activeName="three";
      } else if(status == 2) {
        this.activeName="four";
      } else if(status == 4) {
        this.activeName="five";
      } else if(status == 5) {
        this.activeName="six";
      }
      this.list.page_num = 1;
      this.$router.push({
        path: this.$route.path,
        hash: "#" + this.activeName,
        query: this.list,
      });*/
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleSizeChange (e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleCurrentChange (e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleTabClick (tab) {
      let data = this.list;
      if (tab.name == "first") {
        data.page_size = this.list1.page_size;
        data.page_num = this.list1.page_num;
        data.status = parseInt(this.list1.status);
      } else if (tab.name == "second") {
        data.page_size = this.list2.page_size;
        data.page_num = this.list2.page_num;
        data.status = parseInt(this.list2.status);
      } else if (tab.name == "three") {
        data.page_size = this.list3.page_size;
        data.page_num = this.list3.page_num;
        data.status = parseInt(this.list3.status);
      } else if (tab.name == "four") {
        data.page_size = this.list4.page_size;
        data.page_num = this.list4.page_num;
        data.status = parseInt(this.list4.status);
      } else if (tab.name == "five") {
        data.page_size = this.list5.page_size;
        data.page_num = this.list5.page_num;
        data.status = parseInt(this.list5.status);
      } else if (tab.name == "six") {
        data.page_size = this.list6.page_size;
        data.page_num = this.list6.page_num;
        data.status = parseInt(this.list6.status);
      } else if (tab.name == "seven") {
        data.page_size = this.list7.page_size;
        data.page_num = this.list7.page_num;
        data.status = this.list7.status;
      }
      this.$router.push({
        path: this.$route.path,
        hash: "#" + tab.name,
        query: data,
      });
    },
    async getList () {
      this.loading = true;
      let res = await this.$api.purchase_contract.getList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count1 = res.count1 ? res.count1 : 0;
        this.count2 = res.count2 ? res.count2 : 0;
        this.count3 = res.count3 ? res.count3 : 0;
        this.count4 = res.count4 ? res.count4 : 0;
        this.count5 = res.count7 ? res.count7 : 0;
        this.count6 = res.count8 ? res.count8 : 0;
        this.count7 = res.count6 ? res.count6 : 0;
        switch (this.activeName) {
          case "first":
            this.count = this.count1;
            break;
          case "second":
            this.count = this.count2;
            break;
          case "three":
            this.count = this.count3;
            break;
          case "four":
            this.count = this.count4;
            break;
          case "five":
            this.count = this.count5;
            break;
          case "six":
            this.count = this.count6;
            break;
          case "seven":
            this.count = this.count7;
            break;
          default:
            break;
        }
      }
    },
    initList () {
      let data = this.$route.query;
      if (JSON.stringify(data) != "{}") {
        this.list = this.$utils.cloneDeep(data);
        this.list.status =
          parseInt(this.list.status) || this.list.status == 0
            ? parseInt(this.list.status)
            : this.list.status;
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
        if (this.list.sys_supplier_code) {
          this.getSupplyList(localStorage.getItem("PurchaseContract_query"));
        }
        if (
          this.list.code ||
          this.list.material_info ||
          this.list.sys_supplier_code ||
          this.list.time_begin ||
          this.list.time_end
        ) {
          this.flag = true;
        }
        if (this.list.time_begin && this.list.time_end) {
          this.time = [this.list.time_begin, this.list.time_end];
        }
      } else {
        this.list.status = this.list1.status;
      }
      let status = this.list.status;
      if (status == 1) {
        this.activeName = "first";
      } else if (status == 0) {
        this.activeName = "second";
      } else if (status == -1) {
        this.activeName = "three";
      } else if (status == 2) {
        this.activeName = "four";
      } else if (status == 4) {
        this.activeName = "five";
      } else if (status == 5) {
        this.activeName = "six";
      } else {
        this.list.status = null;
        this.activeName = "seven";
      }
      switch (this.activeName) {
        case "first":
          this.list1.page_size = this.list.page_size;
          this.list1.page_num = this.list.page_num;
          break;
        case "second":
          this.list2.page_size = this.list.page_size;
          this.list2.page_num = this.list.page_num;
          break;
        case "three":
          this.list3.page_size = this.list.page_size;
          this.list3.page_num = this.list.page_num;
          break;
        case "four":
          this.list4.page_size = this.list.page_size;
          this.list4.page_num = this.list.page_num;
          break;
        case "five":
          this.list5.page_size = this.list.page_size;
          this.list5.page_num = this.list.page_num;
          break;
        case "six":
          this.list6.page_size = this.list.page_size;
          this.list6.page_num = this.list.page_num;
          break;
        case "seven":
          this.list7.page_size = this.list.page_size;
          this.list7.page_num = this.list.page_num;
          break;
        default:
          break;
      }
      this.$router.push({
        path: this.$route.path,
        hash: "#" + this.activeName,
        query: this.list,
      });
    },
    init () {
      this.activeName = this.$route.hash
        ? this.$route.hash.split("#")[1]
        : "first";
      this.initList();
      this.getList();
    },
  },
  mounted () {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created () {
    if (
      this.$store.state.token &&
      JSON.stringify(this.$store.state.material_class) == "{}"
    )
      this.getMaterialClass();
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();
    if (this.$store.state.token && this.$store.state.stock_org == false)
      this.getStockOrg();
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>
